import React from 'react';
import { Eye } from 'lucide-react';

interface WizardEndUserStripProps {
  canFill: boolean;
  onGoToQuestions: () => void;
}

/**
 * The RFQ's end user gets their own strip — the generic view-only banner says
 * "ask the owner", which is wrong when the technical steps are theirs to fill.
 */
const WizardEndUserStrip: React.FC<WizardEndUserStripProps> = ({ canFill, onGoToQuestions }) => (
  <div className="flex flex-wrap items-center gap-s4 rounded-card border border-line bg-surface px-[14px] py-[10px]">
    <Eye className="h-4 w-4 shrink-0 text-ink-muted" />
    <p className="m-0 text-body-sm text-ink-secondary">
      {canFill ? (
        <>
          You have view access here — the technical steps are yours to fill.{' '}
          <button
            type="button"
            onClick={onGoToQuestions}
            className="font-semibold text-action underline-offset-2 hover:underline"
          >
            Go to your questions →
          </button>
        </>
      ) : (
        'You have view access to this project.'
      )}
    </p>
  </div>
);

export default WizardEndUserStrip;
